import React, { useEffect, useState, Fragment } from 'react';
import $ from 'jquery';
import { LoadingSpinerComponent } from '../../../Common/loader'
import { trackPromise } from 'react-promise-tracker';

export const FieldListing = ({ fieldFilteringData, handleClick }) => {

    const [fieldFiltering, setFieldFiltering] = useState([]);

    const contentRowNames = ["fieldCode","fieldName", "isActive"]

    useEffect(() => {
        trackPromise(
            setFieldFilteringData()
            )
    }, [fieldFilteringData]);

    async function setFieldFilteringData() {
        destroyDataTable();
        await setFieldFiltering(fieldFilteringData);
        createDataTable();     
    }

    function destroyDataTable(){
        $('#example').DataTable().destroy();
    }

    function createDataTable(){
        $('#example').DataTable();
    }

    const content = (da) => contentRowNames.map((row, index) => {
        return (
            (row === "isActive" ?
                (da[row] === true ? <td key={index}>Active</td> : <td key={index}>Inactive</td>)
                : <td key={index}>{da[row] + " "}</td>
            )
        )
    });

    return (
        <Fragment>
        <LoadingSpinerComponent />
        <div className="row">
            <div className="col-md-12">
                <div className="card">
                        <hr />
                        <div className="table-responsive row-top-gap">
                            <table id="example" className="display dataTable no-footer">
                                <thead>
                                    <tr>
                                        <th>Field Code</th>
                                        <th>Field Name</th>
                                        <th>Status</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {fieldFiltering.map((data, i) => {
                                        return (
                                            <tr key={i}>
                                                {content(data)}
                                                <td onClick={() => handleClick(data)} style={{ cursor: "pointer" }}><i class="far fa-edit"></i></td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>    
                    </div>
                </div>
            </div>
        </div>
    </Fragment>
    )
}


